import React from "react";
import { Box, Chip, Stack, Typography } from "@mui/material";

const FinancePageHeader = ({ title, subtitle, badge = "Gestion financière" }) => {
  return (
    <Box
      sx={{
        mb: 2.5,
        px: { xs: 2, md: 3 },
        py: { xs: 2, md: 2.5 },
        borderRadius: 3,
        background:
          "linear-gradient(135deg, rgba(25,118,210,0.10) 0%, rgba(25,118,210,0.03) 100%)",
        border: "1px solid",
        borderColor: "divider",
        boxShadow: "0 8px 24px rgba(15, 23, 42, 0.05)",
      }}
    >
      <Stack spacing={1}>
        <Box>
          <Chip
            label={badge}
            size="small"
            color="primary"
            variant="outlined"
            sx={{ fontWeight: 800, mb: 1 }}
          />
        </Box>

        <Typography
          variant="h4"
          sx={{
            fontWeight: 900,
            letterSpacing: "-0.03em",
            color: "text.primary",
            lineHeight: 1.15,
          }}
        >
          {title}
        </Typography>

        {subtitle ? (
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{
              maxWidth: 980,
              lineHeight: 1.65,
            }}
          >
            {subtitle}
          </Typography>
        ) : null}
      </Stack>
    </Box>
  );
};

export default FinancePageHeader;